























import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_updateSubUnit, GQL_updateSubUnitVariables } from '@/queries/__generated__/updateSubUnit';
import { GQL_subUnit_subUnit } from '@/queries/__generated__/subUnit';
import { GET_SUBUNIT } from './getSubunit';
import SubUnitForm from '@/components/SubUnit/SubUnitForm.vue';
import gql from 'graphql-tag';

const UPDATE_SUBUNIT = gql`
  mutation updateSubUnit(
    $id: ID!,
    $name: String!,
    $organizationNumber: String!,
    $departmentId: ID!,
  ) {
    updateSubUnit(
      input: {
        subUnit: {
          id: $id,
          name: $name,
          organizationNumber: $organizationNumber,
          departmentId: $departmentId,
        }
      }
    ) {
      subUnit {
        id
        organizationNumber
        name
        department {
          id
          name
        }
      }
    }
  },
`;

@Component({
  components: {
    SubUnitForm,
  },
})
export default class SubUnitEdit extends Vue {
  @Prop([ Number, String ]) private id!: number | string;

  private GET_SUBUNIT = GET_SUBUNIT;
  private UPDATE_SUBUNIT = UPDATE_SUBUNIT;

  private formatData(data: GQL_subUnit_subUnit): GQL_updateSubUnitVariables {
    return {
      ...data,
      departmentId: data.department ? data.department.id : '',
    };
  }

  @Emit()
  private subUnitUpdated(store: InMemoryCache, query: { data: GQL_updateSubUnit }) {
    return query.data.updateSubUnit && query.data.updateSubUnit.subUnit;
  }
}
